module.exports = __webpack_public_path__ + "static/img/ahouais.a55a826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ahouais.png
// module id = 26
// module chunks = 0